import { useEffect } from 'react';

export const useOnKeydown = (onKeydown: (keyEvent: KeyboardEvent) => void) => {
  useEffect(() => {
    let isMounted = true;
    const onKeyDownLocal = (e: KeyboardEvent) => {
      // in case the callback mutates state
      isMounted && onKeydown(e);
    };
    document.addEventListener('keydown', onKeyDownLocal);

    return () => {
      isMounted = false;
      document.removeEventListener('keydown', onKeyDownLocal);
    };
  }, [onKeydown]);
};
